import { render } from "./VDashboard.vue?vue&type=template&id=b5300a16"
import script from "./VDashboard.vue?vue&type=script&lang=js"
export * from "./VDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__